module.exports = __webpack_public_path__ + "static/media/BDO.1cbc979e.png";